import React from 'react';
import { styled } from '@mui/material/styles';
import { SvgIcon } from '../../../types/SvgIcon';
import ConfirmationModalErrorIcon from './icons/ConfirmationModalErrorIcon';
import ConfirmationModalInfoIcon from './icons/ConfirmationModalInfoIcon';
import ConfirmationModalSuccessIcon from './icons/ConfirmationModalSuccessIcon';
import ConfirmationModalWarningIcon from './icons/ConfirmationModalWarningIcon';
import ConfirmationModalNotFoundIcon from './icons/ConfirnationModalNotFoundIcon';
import ConfirmationModalPrimaryIcon from './icons/ConfirmationModalPrimaryIcon';

type Severity = 'error' | 'warning' | 'success' | 'info' | 'primary' |'not-found-warning';

export const icons: { [key in Severity]: SvgIcon } = {
  'error': ConfirmationModalErrorIcon,
  'info': ConfirmationModalInfoIcon,
  'success': ConfirmationModalSuccessIcon,
  'warning': ConfirmationModalWarningIcon,
  'not-found-warning': ConfirmationModalNotFoundIcon,
  'primary': ConfirmationModalPrimaryIcon
};

interface Props {
  severity: Severity;
}

const StyledIcon = (icon: SvgIcon) => styled(icon)(
  ({ theme }) => ({
    display: 'inline-block',
    textAlign: 'center',
    width: 321,
    height: 192,
    '& .success-fill-main': {
      fill: theme.palette.success.main,
    },
    '& .success-fill-container': {
      fill: theme.palette.success.container,
    },
    '& .error-fill-main': {
      fill: theme.palette.error.main,
    },
    '& .error-fill-container': {
      fill: theme.palette.error.container,
    },
    '& .info-fill-main': {
      fill: theme.palette.info.main,
    },
    '& .info-fill-container': {
      fill: theme.palette.info.container,
    },
    '& .warning-fill-main': {
      fill: theme.palette.warning.main,
    },
    '& .warning-fill-container': {
      fill: theme.palette.warning.container,
    },
    '& .primary-fill-main': {
      fill: theme.palette.primary.main,
    },
    '& .primary-fill-container': {
      fill: theme.palette.primary.container,
    },
    '& .stroke-neutral': {
      stroke: theme.palette.neutral.onSurfaceVariant,
    },
    '& .fill-neutral': {
      fill: theme.palette.neutral.onSurfaceVariant,
    },
    '& .neutral-bg': {
      fill: theme.palette.neutral.containerHighest,
    },
    '& .stroke-neutral-bg': {
      stroke: theme.palette.neutral.containerHighest,
    },
    '& .neutral-bg-variant': {
      fill: theme.palette.neutral.outlineVariant,
    },
    '& .stroke-success': {
      stroke: theme.palette.success.onMain,
    },
    '& .fill-success': {
      fill: theme.palette.success.onMain,
    }
  })
);

const TruckSeverityIcon = ({ severity }: Props) => {
  const Icon = StyledIcon(icons[severity]);

  return <Icon />;
};

export default TruckSeverityIcon;
